import { splitLocale } from '../../locale/localeUtils';
export const textTransformTokens = () => {
  return {
    default: 'unset',
    uppercase: 'unset'
  };
};
export const textTransformTokensNova = language => {
  // Split the locale into language, region, and script. Our font family designations contain different combinations of these aspects of the locale.
  const {
    lang
  } = splitLocale(language);
  switch (lang) {
    case 'ar':
    case 'zh':
    case 'ja':
    case 'ko':
    case 'th':
      return {
        default: 'initial',
        uppercase: 'initial'
      };
    default:
      return {
        default: 'initial',
        uppercase: 'uppercase'
      };
  }
};
//# sourceMappingURL=textTransform.js.map